import { Slide } from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';
import { forwardRef } from 'react';

type SlideUpProps = TransitionProps & {
  children: React.ReactElement;
};

export const SlideUp = forwardRef<HTMLDivElement, SlideUpProps>(function SlideUp(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
